import React, { useState, memo } from 'react'
import {  withRouter, RouteComponentProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ClearIcon from '@material-ui/icons/Clear'

import { ICountry, withAppStoreValue, ITour } from '../../../store'
import { EHeaderStateActionTypes, withHeaderStoreValue, HeaderDispatchAction } from '../store';

interface ISearchBoxCoreHeaderStoreProps {
    searchShow: boolean
    dispatch: HeaderDispatchAction
}

interface ISearchBoxCoreAppStoreProps {
    tour: ITour
}

const SearchBoxCore = memo(withRouter((props: RouteComponentProps & ISearchBoxCoreHeaderStoreProps & ISearchBoxCoreAppStoreProps) => {
    const { t, i18n: { languages: [language] } } = useTranslation();
    const { history, location: { state: { country = undefined } = {} }, searchShow, dispatch, tour } = props

    const [searchText, setSearchText] = useState('')

    const actualCountry = tour && tour.country || country as ICountry

    const clearSearch = () => {
        setSearchText('')
        if (searchShow) dispatch({ type: EHeaderStateActionTypes.UpdateSearchShow, value: !searchShow})
    }

    const handleSearch = () => {
        history.push({
            pathname: `/${language}/${actualCountry.slug}/find`,
            state: {
                searchText,
                country: actualCountry
            }
        })
        setSearchText('')
        dispatch({ type: EHeaderStateActionTypes.UpdateSearchShow, value: false})
    }

    return (
        <div className="input-left" style={{ display: searchShow ? 'block' : 'none' }}>
            <div className="search-input">
                <input
                    disabled={!actualCountry}
                    type="text"
                    placeholder={t(!actualCountry ? 'Please select a country first!' : 'Find your place to be!')}
                    value={searchText}
                    onChange={(e) => setSearchText(e.currentTarget.value)}
                    onKeyUp={e => {
                        if (e.keyCode === 13) {
                            handleSearch();
                        }
                    }}
                />
                <div className="search-input-buttons">
                    {(searchText || searchShow) && <button onClick={clearSearch}><ClearIcon /></button>}
                    {searchText && <button onClick={handleSearch}><img src="/images/icons/icon-search.png" alt="search" /></button>}
                </div>

            </div>
        </div>
    )
}))

export const SearchBox = withAppStoreValue(withHeaderStoreValue<ISearchBoxCoreHeaderStoreProps & ISearchBoxCoreAppStoreProps>(SearchBoxCore, ['dispatch', 'searchShow']), ['tour'])